import React, { useState, useRef, useEffect } from "react";
import {
    Box,
    useTheme,
    Button,
    Modal,
    TextField,
    DialogActions,
    DialogContent,
    DialogContentText,
    InputLabel,
    Select,
    MenuItem,
    Typography,
    CircularProgress,
    IconButton,
} from "@mui/material";

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

// import { styled } from '@mui/material/styles';

import { DataGrid, GridApi } from "@mui/x-data-grid";

import { useGetContactUsCategoriesQuery, useCreateContactUsCategoriesMutation, useUpdateContactUsCategoriesMutation, useDeleteContactUsCategoriesMutation } from "state/api";
import { Header } from "components";




const ContactUsCategories = () => {

    const { data, isLoading, refetch } = useGetContactUsCategoriesQuery();


    const [createContactUsCategories] = useCreateContactUsCategoriesMutation();
    const [updateContactUsCategories] = useUpdateContactUsCategoriesMutation();
    const [deleteContactUsCategories] = useDeleteContactUsCategoriesMutation();


    const theme = useTheme();

    const gridApiRef = useRef(null);

    useEffect(() => {
        // Access grid API when it's ready
        if (gridApiRef.current) {
            const api = gridApiRef.current;
            // Perform any actions needed with the grid API here
            // For example, you could set initial selected rows:
            api.setSelectedRows([0]);
        }
    }, [gridApiRef]);

    // data columns
    const columns = [
        // {
        //   field: "_id",
        //   headerName: "ID",
        //   flex: 1,
        // },
        {
            field: "name",
            headerName: "Contact Us Categories Title",
            flex: 1,
            // editable: true,
        },
        // {
        //   field: "description",
        //   headerName: "ContactUsCategories Description",
        //   flex: 1,
        //   // editable: true,
        // },

        {
            field: "actions",
            headerName: "Actions",
            flex: 0.5,
            renderCell: (params) => {
                const { _id } = params.row;
                return (
                    <div>
                        <IconButton
                            color="primary"
                            aria-label="edit"
                            onClick={() => handleOpenEdit(_id)}
                        >
                            <EditIcon sx={{ color: 'white' }} />
                        </IconButton>
                        <IconButton
                            color="error"
                            aria-label="delete"
                            onClick={() => handleDeleteContactUsCategories(_id)}
                        >
                            <DeleteIcon />
                        </IconButton>
                    </div>
                );
            },
        },
    ];

    const [open, setOpen] = useState(false);
    const [name, setname] = useState("");
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [user, setUser] = useState(null);
    const [nameError, setnameError] = useState(null);
    const [ContactUsCategoriesCategory, setContactUsCategoriesCategory] = useState("ContactUsCategories"); // Initial selection
    const [ContactUsCategoriesCategoryError, setContactUsCategoriesCategoryError] = useState(null);
    const [selectedFileError, setSelectedFileError] = useState(null);
    const [descriptionError, setdescriptionError] = useState(null);
    const [isLoadingSubmit, setIsLoadingSubmit] = useState(false); // State for loading indicator
    const [selectedEditRowData, setSelectedEditRowData] = useState(null); // Add this state to store the selected row's data

    const [ContactUsCategoriesEditError, setContactUsCategoriesEditError] = useState(null);


    // New state to track the modified fields
    const [modifiedFields, setModifiedFields] = useState({});

    const handlenameChange = (event) => {
        setname(event.target.value);
        // Update the modified fields
        // setModifiedFields({ ...modifiedFields, name: selectedEditRowData.name });
        setModifiedFields({ ...modifiedFields, name: event.target.value });

        setnameError(event.target.value ? null : "Enter Contact Us Categories name");
    };

    const handleCategoryChange = (event) => {
        setContactUsCategoriesCategory(event.target.value);
        // Update the modified fields
        // setModifiedFields({ ...modifiedFields, ContactUsCategoriesCategory: selectedEditRowData.ContactUsCategoriesCategory });
        setModifiedFields({ ...modifiedFields, ContactUsCategoriesCategory: event.target.value });

        setContactUsCategoriesCategoryError(event.target.value ? null : "Please select a category");
    };



    const handleSubmit = async () => {
        console.log("working");
        // ... other logic

        if (!name) {
            setnameError("Enter Contact Us Categories name");
            return;
        }


        // if (!description) {
        //   setdescriptionError("Enter ContactUsCategories description");
        //   return;
        // }

        setIsLoadingSubmit(true); // Start loading before asynchronous operations
        const updateData = {
            name: name,
        };
        console.log("206 working");
        await createContactUsCategories(updateData);

        setIsLoadingSubmit(false); // Stop loading after data is created

        setOpen(false); // Close the modal after successful submission

        refetch();
    };


    const handleOpenEdit = (id) => {

        const selectedRow = data.find((row) => row._id === id);

        if (selectedRow) {
            setname(selectedRow.name || "");
            setSelectedEditRowData(selectedRow);

            // Set the modified fields to an empty object initially
            setModifiedFields({});

            setOpen(true);
        }
    };


    const handleEditSubmit = async () => {
        // Only send the modified fields to the API
        if (Object.keys(modifiedFields).length > 0) {


            setIsLoadingSubmit(true); // Start loading before asynchronous operations


            const { selectedFile, ...rest } = modifiedFields;


            const editedContactUsCategoriesData = {
                id: selectedEditRowData._id,
                ...modifiedFields,
            };


            await updateContactUsCategories(editedContactUsCategoriesData);

            setIsLoadingSubmit(false);

            setOpen(false);
            refetch();
        }
        else {
            setContactUsCategoriesEditError("Edit a value first");
            return;
        }

        // Rest of the code...
    };

    const handleDeleteContactUsCategories = async (id) => {
        if (window.confirm("Are you sure you want to delete this Contact Us Categories?")) {
            try {
                // await deleteContactUsCategories.mutateAsync(id);
                // await deleteContactUsCategories(id);
                await deleteContactUsCategories({ id: id });
                refetch(); // Reload to reflect changes in the UI
            } catch (error) {
                console.error("Error deleting Contact Us Categories:", error);
            }
        }
    };

    return (
        <Box m="1.5rem 2.5rem">
            {/* Header */}
            {/* <Header title="ContactUsCategories" subtitle="List of ContactUsCategories" /> */}
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Header title="Contact Us Categories" subtitle="List of Contact Us Categories" />
                <Button variant="contained" color="primary" size="medium" onClick={handleOpen}>
                    {'Add Contact Us Categories'}
                </Button>
            </Box>

            {/* Content */}
            <Box
                mt="40px"
                height="75vh"
                sx={{
                    "& .MuiDataGrid-root": {
                        border: "none",
                    },
                    "& .MuiDataGrid-cell": {
                        borderBottom: "none",
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: theme.palette.background.alt,
                        color: theme.palette.secondary[100],
                        borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: theme.palette.primary.light,
                    },
                    "& .MuiDataGrid-footerContainer": {
                        backgroundColor: theme.palette.primary.light,
                        color: theme.palette.secondary[100],
                        borderTop: "none",
                    },
                    "& .MuiDataGrid-toolbarContainer .MuiButtom-text": {
                        color: `${theme.palette.secondary[200]} !important`,
                    },
                }}
            >
                {/* Grid table */}
                <DataGrid
                    loading={isLoading || !data}
                    getRowId={(row) => row._id}
                    rows={data || []}
                    columns={columns}
                // editMode="row"
                // // Handle row edit functionality (optional)
                // onRowEditCommit={({ id, ...newData }) => {
                //   // Update the edited data using the updateContactUsCategories mutation
                //   // updateContactUsCategories.mutateAsync({ id, ...newData });
                // }}
                // apiRef={gridApiRef}
                />
            </Box>


            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{
                    minWidth: 500, // Adjust the minimum width for your modal
                    p: 4, // Add padding inside the modal
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper', // Set white background
                    borderRadius: 2,           // Add rounded borders (adjust the value)
                    boxShadow: 24
                }}>

                    <DialogContent>
                        {/* Error messages */}
                        {nameError && <Typography variant="caption" color="error">{nameError}</Typography>}
                        {selectedFileError && <Typography variant="caption" color="error">{selectedFileError}</Typography>}
                        {ContactUsCategoriesEditError && <Typography variant="caption" color="error">{ContactUsCategoriesEditError}</Typography>}

                        <DialogContentText>
                            {!selectedEditRowData ? "Add a new Contact Us Categories" : "Edit Contact Us Categories"}
                        </DialogContentText>
                        <TextField
                            label="Contact Us Categories Name"
                            value={name}
                            onChange={handlenameChange}
                            error={!!nameError} // Set error prop based on error state
                            helperText={nameError} // Set helper text for error display
                            fullWidth
                            margin="normal"
                        />
                        <br />

                        <br />

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="primary">
                            Cancel
                        </Button>
                        {/* <Button onClick={handleSubmit} color="primary">
              Save
            </Button> */}

                        <Button onClick={!selectedEditRowData ? handleSubmit : handleEditSubmit} color="primary" disabled={isLoadingSubmit}>
                            {isLoadingSubmit ? <CircularProgress size="medium" style={{ width: 20, height: 20, color: 'white' }} /> : 'Save'}
                            {/* Save */}
                        </Button>

                    </DialogActions>
                </Box>
            </Modal>
        </Box>
    );
};

export default ContactUsCategories;
